import { Container } from "@mui/material";
import Page from "../components/Page";

export default function Site({ children }) {
    return (
        <Page title="Site | HCC">
            <Container maxWidth="xl">{children}</Container>
        </Page>
    );
}
